export default "/icon-sliders.svg";